"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = toFormUrlEncoded;
function toFormUrlEncoded(data) {
    if (typeof data !== 'object' || data === null) {
        return data;
    }
    return Object.keys(data)
        .filter(function (key) { return data[key] !== undefined; })
        .map(function (key) {
        var value = data[key];
        if (typeof value === 'string') {
            return "".concat(key, "=").concat(encodeURIComponent(value));
        }
        return "".concat(key, "=").concat(encodeURIComponent(JSON.stringify(value) || ''));
    })
        .join('&');
}
